export default "__VITE_ASSET__BK0Ql0bA__"